import { gql } from '@apollo/client'

export default gql(`
    mutation addVirtualAssetVideos($videoContent: [CreateAssetVideoInput] $project: String $module: String) {
        addVirtualAssetVideos(
            input: $videoContent
            project: $project
            module: $module
        ) {
            id
            assetId
            mediaId
            fileName
            createdAt
            name
            fileSize
            cuePoints
            adPositions
            breakDuration
            cuePointsError
            tags{
                key
                name
                type
            }
            category{
                id
                label
                type
            }
            type
            vodStatus{
                id
                startTime
                endTime
                channel{
                    id
                    icon{
                        id
                        fileName
                        aspectRatio {
                            aspectRatio
                            ratio
                            title          
                            resolutions {
                            url
                            }
                        }
                        settings {
                            aspectRatio
                            outputFormat
                            fileName
                            x1
                            y1
                            x2
                            y2
                        }
                    }
                }
            }
            drmContent
            streams{
                id
                drm
                codec
                Url
                iv
                transport
                contentKey
                PackagingConfigurationId
            }
            _originalResponseBody 
            duration
            thumbnails
            isDefault
        }
    }`
)
